import React from 'react'
import styled from 'styled-components';
import { colours, commonDimensions, heights } from '../Styles';
import PackageCard from './PackageCard';
import { goldPackage, platinumPackage } from '../PackageDetails';

function PackageStrip() {
    const { light } = colours;
    const { h2Margin } = commonDimensions;
    const { mobileHeader, contactBar } = heights;
const PackageStrip = styled.div`
    min-height: calc(100vh - ${mobileHeader});
    width: 100%;
    background: ${light};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: ${contactBar};
    h2 {
        margin: ${h2Margin};
    }
    #card-wrap {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        // align-items: center;
        justify-content: center;
    }
`;

    return (
        <PackageStrip>
            <h2 id="packages">Packages</h2>
            <div id="card-wrap">
                <PackageCard imgsrc={goldPackage.packageImg} imgalt='gold package img' barText={goldPackage.barText} options={goldPackage.options} description={goldPackage.description} name={goldPackage.name}/>
                <PackageCard imgsrc={platinumPackage.packageImg} imgalt='platinum package img' barText={platinumPackage.barText} options={platinumPackage.options} description={platinumPackage.description} name={platinumPackage.name}/>
            </div>
        </PackageStrip>
    )
}

export default PackageStrip;